import consumer from "./consumer"

import { MonthCalendar } from "../packs/calendars/month";
import { WeekCalendar } from "../packs/calendars/week";
import { DayCalendar } from "../packs/calendars/day";

$(function () {
  var selectedDate = null
  let params = new URLSearchParams(location.search)

  if (isSubscriptionsPath()) {
    let stmcCode = location.pathname.split('/')[1];

    consumer.subscriptions.create({ channel: "WaitlistChannel", stmc_code: stmcCode }, {
      received(data) {
        let date = params.get("date");
        let entryTime = new Date(data.entry_time)
        selectedDate = date ? new Date(date) : new Date()
        if (!(entryTime.getFullYear() == selectedDate.getFullYear() && entryTime.getMonth() + 1 == selectedDate.getMonth() + 1 && entryTime.getDate() == selectedDate.getDate())) return
        notifyRecentArrival(data)
      },
    });
  };

  displaySoundPermission()
  let calObj = setCalenderObj();

  function setCalenderObj() {
    if (params.get('calendar_type') == 'month') return MonthCalendar.generate();
    if (params.get('calendar_type') == 'week') return WeekCalendar.generate();
    return DayCalendar.generate();
  }

  function isSubscriptionsPath() {
    return "waitlists" == location.pathname.split('/')[2]
  }

  function notifyRecentArrival(data) {
    let waitlistViewModeIsCalendar = $('#waitlist_view_mode').val() == 'calendar';
    if (JSON.parse(data.is_create)) {
      createPush('新着の受付があります。');
      displayRecentArrivalBatchForTab(data.recent_entry_tab_id, data.default_tab_id);
      if (waitlistViewModeIsCalendar) {
        calendarPartialUpdate();
      } else {
        waitlistsPartialUpdate();
        displayRecentArrivalCount();
      }
      // 音が有効の場合のみ
      if (localStorage.getItem('sound-disable') == null) {
        createNotificationSound();
      }
    } else if (JSON.parse(data.is_cancel)) {
      waitlistViewModeIsCalendar ? calendarPartialUpdate() : waitlistsPartialUpdate();
      createPush('受付がキャンセルされました。');
    } else {
      waitlistViewModeIsCalendar ? calendarPartialUpdate() : waitlistsPartialUpdate();
    }
  }

  // 受付一覧の部分更新
  function waitlistsPartialUpdate() {
    let targetPath = location.pathname;
    // ソトマチ・保留・完了一覧以外のpath以外が来ることはない気はするが、
    // 万が一別のpathがきた際にこの処理が走ると表示が崩れるため一応チェックしている
    let pathCheck = targetPath.includes('waitings') || targetPath.includes('holdings') || targetPath.includes('completed');
    if (!pathCheck) { return };
    $.ajax({
      type: 'GET',
      url: targetPath,
      data: {
        date: `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`,
        required_item_id: params.get('required_item_id'),
        tab_id: params.get('tab_id'),
        calendar_type: params.get('calendar_type')
      },
      dataType: 'html'
    }).done(function (result) {
      // タブの受付件数表示箇所の部分更新
      $('.tab-item').each(function (index, element) {
        let tabPartialUpdateList = $('.js-tab-partial-update', $(result));
        $(element).html(tabPartialUpdateList[index]);
      });

      // 画面更新前に受付エリアのスクロール位置を取っておく
      const currentScrollPosition = document.getElementsByClassName('waitlist-area')[0].scrollTop;

      // モーダルが開いている場合部分更新を行うとバグが起きるため、モーダルを閉じた際に部分更新を行う
      if ($('body').hasClass('modal-open')) {
        let showModal = $('.modal.show')
        showModal.on('hidden.bs.modal', function (e) {
          $('.tab-area').html($('.waitlist-area', $(result)));
          $('[data-toggle="tooltip"]').tooltip();
          setHeightToWaitlistArea(currentScrollPosition);
        });
      } else {
        $('.tab-area').html($('.waitlist-area', $(result)));
        $('[data-toggle="tooltip"]').tooltip();
      }

      // 完了, 保留, 問診依頼、再撮影依頼ボタン押下時
      $('.js-btn-complete, .js-btn-pending, .js-btn-request_interview, .js-btn-call, .js-btn-requested_card_resend').on('click', (e) => {
        $(this).prop('disabled', 'true');
        e.preventDefault();
        e.stopPropagation();
        const target = e.target;
        const link = e.target.href;
        const text = e.target.text;
        actionConfirmModal(target, link, text);
      });

      createWaitlistModal();
      tmpReservationModal();
      setHeightToWaitlistArea(currentScrollPosition);
    }).fail(function (err) {
      console.log(err);
    })
  }

  // カレンダーの部分更新
  function calendarPartialUpdate() {
    if (params.get('calendar_type') == 'week') {
      return location.reload();
    }

    let targetPath = location.pathname;

    $.ajax({
      type: 'GET',
      url: targetPath,
      data: {
        date: `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`,
        required_item_id: params.get('required_item_id'),
        tab_id: params.get('tab_id'),
        calendar_type: params.get('calendar_type')
      },
      dataType: 'html'
    }).done(function (result) {
      // タブの受付件数表示箇所の部分更新
      $('.tab-item').each(function (index, element) {
        let tabPartialUpdateList = $('.js-tab-partial-update', $(result));
        $(element).html(tabPartialUpdateList[index]);
      });

      // 部分更新を行う際tooltipが出ていると残ってしまうので
      // ここで全て消す
      removeAllTooltips();

      // カレンダーを一度リセット
      calObj.removeAllEvents();
      // カレンダーイベントの更新
      let calendarEvents = $(result).find('#calendar-events').data('events');
      calObj.addEventSource({ events: calendarEvents });

      // 画面更新後ツールチップが残ってしまっている可能性があるため削除する
      $(".tooltip").remove();
      // ツールチップを初期化する(これがないと崩れる)
      $('.event-content-tooltip').tooltip();

      createWaitlistModal();
    }).fail(function (err) {
      console.log(err);
    })
  }

  // Waitlist確認モーダル
  function actionConfirmModal(target, link, text) {
    const isRequestInterview = $(target).hasClass('js-btn-request_interview');
    const isCall = $(target).hasClass('js-btn-call');
    const isRequestedCardResend = $(target).hasClass('js-btn-requested_card_resend');
    let config = {
      showConfirmButton: true,
      showCancelButton: true,
      timer: null,
      allowOutsideClick: true,
      confirmButtonColor: '#16a378',
      cancelButtonText: "いいえ",
    };
    let addConfig = {};

    if (isRequestInterview) {  // 問診依頼
      addConfig = {
        title: '問診の入力を依頼する',
        text: 'LINEを送信しますがよろしいですか？',
        confirmButtonText: '送信する'
      }
    } else if (isCall) {
      addConfig = {
        title: '呼び出しする',
        text: '呼び出しは取り消しできません。よろしいですか？',
        confirmButtonText: '呼び出す'
      }
    } else if (isRequestedCardResend) {
      addConfig = {
        title: '再撮影依頼する',
        text: '再撮影依頼は取り消しできません。よろしいですか？',
        confirmButtonText: '再撮影依頼'
      }
    } else { // タブ移動
      addConfig = {
        title: `${text}に移動する`,
        text: '元に戻せませんがよろしいですか？',
        confirmButtonText: '移動する'
      }
    }
    config = { ...config, ...addConfig };

    Swal.fire(config).then((e) => {
      if (e.isConfirmed) {
        $.ajax({ url: link, type: "GET" });
        if (!isRequestInterview && !isCall && !isRequestedCardResend) {
          $(target).closest('.js-waitlist').fadeOut();
        }
      }
    });
  }

  // push通知の作成
  function createPush(content) {
    Push.create(content, {
      icon: '../../../favicon.ico',
      timeout: 10000,
      onClick: function () {
        window.focus();
        this.close();
      }
    });
  }

  // 通知音の作成
  function createNotificationSound() {
    let context = new AudioContext();
    let source = context.createBufferSource();

    let request = new XMLHttpRequest();
    request.open('GET', '/push_notification.mp3', true);
    request.responseType = 'arraybuffer';
    request.send();

    request.onload = function () {
      let res = request.response;
      context.decodeAudioData(res, function (buf) {
        source.buffer = buf;
      });
    };

    source.connect(context.destination);
    source.start();
    source.stop(1);
  }

  // 新着の受付の件数を画面下部に表示
  function displayRecentArrivalCount() {
    if ($(document).innerHeight() > $(window).innerHeight()) {
      // 新着お知らせメッセージに表示している新着の受付の件数を更新
      let currentCount = Number($('.recent-arrival-count').text());
      if (!isNaN(currentCount)) { $('.recent-arrival-count').text(currentCount + 1) }
      $('.recent-arrival-notification').show();
    }
  }

  // 現在開いているタブと別のタブで新着の受付があった場合にバッチを表示
  function displayRecentArrivalBatchForTab(recentEntryTabId, defaultTabId) {
    // 現在のタブを取得し取得できなければデフォルトのタブであると判定する
    var currentTabId = params.get('tab_id')
    if (!currentTabId) currentTabId = defaultTabId

    $('.tab-item').each(function () {
      let dataTabId = $(this).data('tab-id');
      if (Number(dataTabId) === Number(recentEntryTabId) && Number(dataTabId) !== Number(currentTabId)) {
        $(this).addClass('recent-arrival-batch');
      }
    });
  }

  // 新着お知らせメッセージを消すためのスクロールイベント
  $(window).on('scroll', function () {
    let docHeight = $(document).innerHeight(); //ドキュメントの高さ
    let windowHeight = $(window).innerHeight(); //ウィンドウの高さ
    let pageBottom = docHeight - windowHeight;
    if (pageBottom <= $(window).scrollTop()) {
      //ウィンドウの一番下までスクロールした時に新着お知らせメッセージを消す
      $('.recent-arrival-notification').hide();
      // 新着お知らせメッセージに表示している新着の受付の件数をリセット
      $('.recent-arrival-count').text('');
    }
  })

  // 新着お知らせメッセージを消すボタンのクリックイベント
  $('.notification-close-button').on('click', function () {
    $('.recent-arrival-notification').hide();
    // 新着お知らせメッセージに表示している新着の受付の件数をリセット
    $('.recent-arrival-count').text('');
  });

  // 音声通知許可のダイアログ
  // 音を鳴らすには何かしらのマウス操作が必要なため一度ポップアップを押してもらう
  function displaySoundPermission() {
    if (localStorage.getItem('sound-disable') == null) {
      // 音が有効の場合ダイアログ表示
      if (performance.getEntriesByType("navigation")[0].type === 'reload') {
        // 画面更新されたらセッション削除し、改めて通知許可ポップアップを開く
        sessionStorage.removeItem('sound-permission');
      } else if (performance.getEntriesByType("navigation")[0].type === 'navigate') {
        // 画面遷移したらセッション設定し、通知許可ポップアップは開かない
        sessionStorage.setItem('sound-permission', true);
      }

      // 新着通知音許可ポップアップignore設定されている場合(仮予約の時のみ)
      if (sessionStorage.getItem('sound-permission-ignore') !== null) {
        // セッション設定し、通知許可ポップアップは開かない
        sessionStorage.setItem('sound-permission', true);
        sessionStorage.removeItem('sound-permission-ignore');
      }
      if (sessionStorage.getItem('sound-permission') === null) {
        // 通知許可がされていない場合
        $('.sound-permission').show();
      }
    } else {
      // 音が無効の場合ダイアログ表示せず、アイコン切り替える
      let icon = $('.js-volume').find('i');
      icon.removeClass('fa-volume-up');
      icon.addClass('fa-volume-mute');
    }
  }

  // 新着通知音許可メッセージを消すボタンのクリックイベント
  $('.sound-permission-close-button').on('click', function () {
    $('.sound-permission').hide();
    sessionStorage.setItem('sound-permission', true);
  });

  $('.js-volume').on('click', function () {
    let icon = $(this).find('i');
    if (localStorage.getItem('sound-disable') == null) {
      // 音を有効→無効に切り替えの場合
      localStorage.setItem('sound-disable', true);
      icon.removeClass('fa-volume-up');
      icon.addClass('fa-volume-mute');
      $('.sound-permission').hide();
    } else {
      // 音を無効→有効に切り替えの場合
      localStorage.removeItem('sound-disable');
      icon.removeClass('fa-volume-mute');
      icon.addClass('fa-volume-up');
      if (sessionStorage.getItem('sound-permission') === null) {
        // 通知許可がされていない場合
        $('.sound-permission').show();
      }
    }
  });

  // Waitlist登録用モーダルの処理
  createWaitlistModal();
  function createWaitlistModal() {
    $('.js-btn-add-waitlist').on('click', (e) => {
      let entryTime = e.target.dataset.date
      let staffId = e.target.dataset.staffId
      // 仮予約
      $('#waitlist_entry_time').val(entryTime);

      // 予約
      $('.js-modal-entry-time').val(entryTime);
      // シフトに入っているstaff一覧取得
      let stmcCode = location.pathname.split('/')[1];
      $.ajax({
        type: 'GET',
        url: `/${stmcCode}/hospital/staffs_on_shift`,
        data: {
          date: entryTime,
          staff_id: staffId,
        }
      }).done(function (data) {
        // 仮予約
        let tmpStaffIdForm = $('.js-modal-tmp-staff-id');
        tmpStaffIdForm.children().remove();
        $.each(data, function (index, value) {
          tmpStaffIdForm.append(`<option value="${value['id']}">${value['name_with_shift']}</option>`);
        });
        // 予約
        let staffIdForm = $('.js-modal-staff-id');
        staffIdForm.children().remove();
        $.each(data, function (index, value) {
          staffIdForm.append(`<option value="${value['id']}">${value['name_with_shift']}</option>`);
        });
      });
    });
  }

  // 一覧表示：仮予約処理
  tmpReservationModal();
  function tmpReservationModal() {
    $('.js-btn-tmp-reservation').on('click', (e) => {
      $('#waitlist_entry_time').val(e.target.dataset.date);
      if (e.target.dataset.isAm === 'true') {
        $('.am_staffs').show();
        $('.am_staffs').prop('disabled', false);
        $('.pm_staffs').hide();
        $('.pm_staffs').prop('disabled', true);
      } else if (e.target.dataset.isPm === 'true') {
        $('.am_staffs').hide();
        $('.am_staffs').prop('disabled', true);
        $('.pm_staffs').show();
        $('.pm_staffs').prop('disabled', false);
      };
    });
  }
  function setHeightToWaitlistArea(currentScrollPosition) {
    // カレンダー表示ではない場合に処理を行う
    if (!document.getElementById('day-calendar')) {
      // waitlist-areaに高さを付与する
      const targetElements = document.getElementsByClassName('waitlist-area');
      for (let i = 0; i < targetElements.length; i++) {
        let documentHeight = window.innerHeight;
        // 比率で余白を決めるようにする
        let marginSize = documentHeight / 5.5;
        targetElements[i].style.height = `${documentHeight - marginSize}px`;
        targetElements[i].style.overflow = "scroll";
        targetElements[i].scrollTop = currentScrollPosition;
      }
    }
  }
  function removeAllTooltips() {
    const tooltipElements = document.getElementsByClassName("tooltip fade show");
    Array.from(tooltipElements).forEach(element => {
      element.remove();
    });
  }
})
